import { CareCreditIntegration } from '@weave/schema-gen-ts/dist/schemas/payments-platform/care-credit-integration/care_credit_integration.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaCareCreditIntegrationV1Service = bindHTTP(CareCreditIntegration);
export const serviceName = 'care-credit-integration-v1' as const;
